import {
    CoachableMetric,
    CommitmentFocusSummarySetDto,
    CommitmentKpi,
} from '../../coaching-base/general';
import { SortDirection } from '../../coaching-insight/oa/models/sorting.model';
import {
    MetricData,
    MetricDataItem,
} from '../../performance-data/metric.pd.model';
import { CommitmentGoalHistory } from '../models/commitment-goal-history.model';
import { FocusKPI } from '../models/commitment.model';
import { GoalDataPoint } from '../models/goal-data-point.model';
import { GoalEventDataPoint } from '../models/goal-event-data-point.model';

import { GoalFormValue } from './goals.commitment.form';

export interface GoalCommitmentState {
    pending: {
        init?: boolean;
        data?: boolean;
        goals?: boolean;
        history?: boolean;
        events?: boolean;
    };

    focusSummarySet?: CommitmentFocusSummarySetDto;
    metrics?: CoachableMetric[];
    metricData?: MetricData;
    lastMetricDataItem?: MetricDataItem;
    activeGoalsWithMetric?: GoalFormValue[];

    selected?: GoalFormValue;
    commitmentKpis?: CommitmentKpi[];
    focusKpis?: FocusKPI[];
    goalsFromOtherCommitments?: CommitmentKpi[];

    goalsSortDirection?: SortDirection;

    goalHistory?: CommitmentGoalHistory[];
    goalDataPoints?: GoalDataPoint[];
    goalEventDataPoints?: GoalEventDataPoint[];
}

export const defaultGoalCommitmentState = (): GoalCommitmentState => ({
    pending: {},
    goalsSortDirection: SortDirection.DESC,
});
